import React, { useState } from 'react';
import LoginForm from './LoginForm';

const Login = ({ onClose, fromLocationData, from, phone, setPhone }) => {
    const [loading, setLoading] = useState(false);
    const [isErrorOpen, setIsErrorOpen] = useState(false);
    const [errorText, setErrorText] = useState('IncorrectPhoneNumber');

    return <div className="popup-tab-content" id="login">
        <LoginForm
            onClose={onClose}
            fromLocationData={fromLocationData}
            from={from}
            loading={loading}
            setLoading={setLoading}
            setPhone={setPhone}
            phone={phone}
            setIsErrorOpen={setIsErrorOpen}
            isErrorOpen={isErrorOpen}
            errorText={errorText}
            setErrorText={setErrorText}
        />
    </div>;
};

export default Login;
